import { CustomForm } from "../../customform/CustomForm";
import FormRow from "../../customform/layout/FormRow";
import { FieldAlias, FieldTypeId } from "../../../lib/enums";
import { useStoreContext } from "../../..";
import { useEffect } from "react";
import { observer } from "mobx-react";
import {
  Measurement,
  MeasurementSaveRequest,
} from "../../../models/Measurements";
import CustomDatePicker from "../../customform/fields/DateTime/CustomDatePicker";
import CustomCheckboxGroup from "../../customform/fields/Checkbox/CustomCheckboxGroup";
import { GenericDataFormSchema } from "../../customform/types";

const SymptomDiaryEntryForm = observer(
  ({
    selectedDay,
    onDeSelect,
  }: {
    selectedDay: any | undefined;
    onDeSelect: () => void;
  }) => {
    const symptomFieldAliases = [
      FieldAlias.C_F_D_DIARY_COLD,
      FieldAlias.C_F_D_DIARY_DRYCOUGH,
      FieldAlias.C_F_D_DIARY_EARPAIN,
      FieldAlias.C_F_D_DIARY_FEELINGSICK,
      FieldAlias.C_F_D_DIARY_FEVER,
      FieldAlias.C_F_D_DIARY_FLEMCOUGH,
      FieldAlias.C_F_D_DIARY_MORNINGCOUGH,
      FieldAlias.C_F_D_DIARY_STOMACHACHE,
      FieldAlias.C_F_D_DIARY_THROATPAIN,
      FieldAlias.C_F_D_DIARY_TIREDNESS,
      FieldAlias.C_F_D_DIARY_NOSYMPTOM,
    ];

    const { measurementStore, fieldStore } = useStoreContext();

    const saveSymptoms = async (data: any) => {
      if (!data) {
        return;
      }
      const saveRequests: MeasurementSaveRequest[] = [];

      data.symptoms.forEach((alias: string) => {
        saveRequests.push({
          date: data.date,
          fieldAlias: alias,
          value: "1000773",
        });
      });
      saveRequests.forEach(async (request) => {
        await measurementStore.saveMeasurement(
          request as MeasurementSaveRequest
        );
      });

      await measurementStore.getSymptoms();
    };

    const updateSymptoms = async (form: any) => {
      if (!form) {
        return;
      }
      const saveRequests: MeasurementSaveRequest[] = [];

      form.symptoms.forEach((data: Measurement | string) => {
        if (typeof data === "string") {
          saveRequests.push({
            date: form.date,
            fieldAlias: data,
            value: "1000773",
          });
          return;
        }
      });

      saveRequests.forEach(async (request) => {
        await measurementStore.saveMeasurement(
          request as MeasurementSaveRequest
        );
      });

      await measurementStore.getSymptoms();
    };

    useEffect(() => {
      if (!measurementStore.symptoms) {
        measurementStore.getSymptoms();
      }
    }, [measurementStore.symptoms]);

    useEffect(() => {
      const fetchFields = async () => {
        if (!fieldStore.fields) {
          await fieldStore.getFields();
        }
      };
      fetchFields();
    }, []);

    return (
      <>
        {fieldStore.fields && (
          <CustomForm
            hideDeleteAndEditButtons
            hideReadOnlyChip
            hideSaveButton
            zodDataSchema={GenericDataFormSchema}
            currentData={selectedDay as any}
            onSave={saveSymptoms}
            onUpdate={updateSymptoms}
            onDeSelect={onDeSelect}
          >
            <FormRow gapAfter>
              <CustomDatePicker
                required
                alias="date"
                header="Datum"
                fieldId={0}
                typeId={FieldTypeId.DATE}
                nonForm
                validations={[
                  {
                    isNotInFuture: "date",
                  },
                ]}
              />
            </FormRow>
            <FormRow>
              <CustomCheckboxGroup
                fieldId={1}
                alias="symptoms"
                header="Symptom"
                fieldOptions={
                  symptomFieldAliases.map((alias) => {
                    const field = fieldStore.fields?.find(
                      (a) => a.alias === alias
                    );
                    if (!field) {
                      throw new Error(`No field found for alias: ${alias}`);
                    }
                    return {
                      fieldAlias: field.alias,
                      name: field.header,
                    };
                  }) as any
                }
                valueProp={"fieldAlias"}
                labelProp={"name"}
                defaultValue={"1000773"}
                disabledOptions={selectedDay?.symptoms.map(
                  (a: any) => a.fieldAlias
                )}
                typeId={FieldTypeId.CHECKBOX_LIST}
                nonForm
                required
              />
            </FormRow>
          </CustomForm>
        )}
      </>
    );
  }
);

export default SymptomDiaryEntryForm;
